// extracted by mini-css-extract-plugin
export default {"commercialItem":"CommercialItem_commercialItem__jew3q"};